// src/ProjectsSection.js
import { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

const FALLBACK_IMG = '/images/projects/fallback.jpg';

const projects = [
  {
    id: 1,
    title: 'Κατάστημα παπουτσιών',
    description:
      'Ολοκληρωμένη αναβάθμιση εμπορικού χώρου με σύγχρονη αισθητική, νέες κατασκευές και λειτουργικό φωτισμό.',
    cover: '/images/projects/project1-4.jpg',
    gallery: [
      '/images/projects/project1-4.jpg',
      '/images/projects/project1-1.JPEG',
      '/images/projects/project1-2.JPEG',
      '/images/projects/project1-3.JPEG',
      '/images/projects/project1-5.JPEG',
      '/images/projects/project1-6.jpg',
      '/images/projects/project1-7.jpg',
      '/images/projects/project1-8.JPEG',
      '/images/projects/project1-9.JPEG',
      '/images/projects/project1-10.JPEG',
      '/images/projects/project1-11.JPEG',
      '/images/projects/project1-12.JPEG',
    ],
  },
  {
    id: 2,
    title: 'Κατάστημα οπτικών',
    description:
      'Σχεδιασμός και κατασκευή βιτρινών/εκθετηρίων με καθαρές γραμμές, έμφαση στην προβολή προϊόντων και την εμπειρία πελάτη.',
    cover: '/images/projects/project2-1.jpg',
    gallery: [
      '/images/projects/project2-1.jpg',
      '/images/projects/project2-2.jpg',
      '/images/projects/project2-3.jpg',
      '/images/projects/project2-4.jpg',
      '/images/projects/project2-5.jpg',
    ],
  },
  {
    id: 3,
    title: 'Εργαστήριο',
    description:
      'Διαμόρφωση τεχνικού χώρου με βελτιστοποιημένη ροή εργασίας, αποθηκευτικές λύσεις και ανθεκτικά υλικά.',
    cover: '/images/projects/project3-1.JPEG',
    gallery: [
      '/images/projects/project3-1.JPEG',
      '/images/projects/project3-2.JPEG',
      '/images/projects/project3-3.JPEG',
      '/images/projects/project3-4.JPEG',
      '/images/projects/project3-5.JPEG',
      '/images/projects/project3-6.JPEG',
      '/images/projects/project3-7.JPEG',
      '/images/projects/project3-8.JPEG',
    ],
  },
  {
    id: 4,
    title: 'Ανακαίνιση κατοικιών',
    description:
      'Ολικές/μερικές ανακαινίσεις με έμφαση στη λειτουργικότητα: κουζίνες, μπάνια, δάπεδα, φωτισμός και ειδικές κατασκευές.',
    cover: '/images/projects/project4-1.JPEG',
    gallery: [
      '/images/projects/project4-1.JPEG',
      '/images/projects/project4-2.JPEG',
      '/images/projects/project4-3.JPEG',
      '/images/projects/project4-4.JPEG',
      '/images/projects/project4-5.JPEG',
      '/images/projects/project4-6.jpg',
      '/images/projects/project4-7.jpg',
      '/images/projects/project4-8.jpg',
      '/images/projects/project4-9.jpg',
      '/images/projects/project4-10.jpg',
      '/images/projects/project4-11.jpg',
      '/images/projects/project4-12.jpg',
      '/images/projects/project4-13.jpg',
      '/images/projects/project4-14.jpg',
      '/images/projects/project4-15.jpg',
      '/images/projects/project4-16.jpg',
    ],
  },
  {
    id: 5,
    title: 'Γραφεία open-space & Εσωτερικές Διαμορφώσεις',
    description:
      'Διαμόρφωση open-space με διαχωριστικά, ψευδοροφές και ηλεκτρολογικές/φωτιστικές παρεμβάσεις για καθαρό, σύγχρονο αποτέλεσμα.',
    cover: '/images/projects/project5-1.jpg',
    gallery: [
      '/images/projects/project5-1.jpg',
      '/images/projects/project5-2.jpg',
      '/images/projects/project5-3.jpg',
      '/images/projects/project5-4.jpg',
      '/images/projects/project5-5.jpg',
      '/images/projects/project5-6.jpg',
      '/images/projects/project5-7.jpg',
    ],
  },
  {
    id: 6,
    title: 'Επαγγελματικοί Χώροι Γραφείων',
    description:
      'Ανακαίνιση γραφείων με σύγχρονο layout, λύσεις αποθήκευσης και προσεγμένο φωτισμό για άνετη καθημερινή χρήση.',
    cover: '/images/projects/project6-4.JPEG',
    gallery: [
      '/images/projects/project6-1.JPEG',
      '/images/projects/project6-2.JPEG',
      '/images/projects/project6-3.JPEG',
      '/images/projects/project6-4.JPEG',
      '/images/projects/project6-5.JPEG',
      '/images/projects/project6-6.JPEG',
      '/images/projects/project6-7.JPEG',
      '/images/projects/project6-8.JPEG',
      '/images/projects/project6-9.JPEG',
      '/images/projects/project6-10.JPEG',
      '/images/projects/project6-11.jpg',
    ],
  },
  {
    id: 7,
    title: 'Διαμόρφωση Σχολής Χορού',
    description:
      'Ανακαίνιση χώρου εκπαίδευσης με έμφαση στην κίνηση και την άνεση: δάπεδα, φωτισμός, καθρέφτες και εργονομικές λεπτομέρειες.',
    cover: '/images/projects/project7-6.JPEG',
    gallery: [
      '/images/projects/project7-1.JPEG',
      '/images/projects/project7-2.JPEG',
      '/images/projects/project7-3.JPEG',
      '/images/projects/project7-4.JPEG',
      '/images/projects/project7-5.JPEG',
      '/images/projects/project7-6.JPEG',
      '/images/projects/project7-7.JPEG',
    ],
  },
];

function ProjectsSection() {
  const [activeProject, setActiveProject] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const openProject = (project) => {
    setActiveProject(project);
    setLightboxOpen(false);
    setLightboxIndex(0);
  };

  const openImage = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  const closeProject = () => {
    setActiveProject(null);
    setLightboxOpen(false);
  };

  return (
    <>
      <section id="projects" className="section section-alt">
        <div className="container">
          <h2 className="section-title">Έργα</h2>
          <p className="section-subtitle">
            Μερικά από τα έργα που έχει ολοκληρώσει η Tito Constructions.
          </p>

          <div className="projects-grid">
            {projects.map((project) => (
              <button
                key={project.id}
                className="project-card project-clickable"
                onClick={() => openProject(project)}
                type="button"
              >
                <div className="project-image">
                  <img
                    src={project.cover}
                    alt={project.title}
                    onError={(e) => {
                      e.currentTarget.src = FALLBACK_IMG;
                    }}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />
                </div>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
              </button>
            ))}
          </div>
        </div>

        {/* Modal */}
        {activeProject && (
          <div className="modal-backdrop" onClick={closeProject}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>{activeProject.title}</h3>
                <button className="modal-close" onClick={closeProject} type="button">
                  ×
                </button>
              </div>

              <p className="modal-description">{activeProject.description}</p>

              {/* Featured image (click to open lightbox) */}
              <div style={{ borderRadius: 12, overflow: 'hidden', marginBottom: 14 }}>
                <img
                  src={activeProject.gallery[0]}
                  alt={`${activeProject.title} featured`}
                  onClick={() => openImage(0)}
                  onError={(e) => {
                    e.currentTarget.src = FALLBACK_IMG;
                  }}
                  style={{
                    width: '100%',
                    height: 320,
                    objectFit: 'cover',
                    cursor: 'pointer',
                    display: 'block',
                  }}
                />
              </div>

 {/* Thumbnails (χωρίς το εξώφυλλο) */}
<div className="modal-gallery">
  {activeProject.gallery.slice(1).map((src, i) => (
    <img
      key={src}
      src={src}
      alt={`${activeProject.title} ${i + 2}`}
      className="modal-image"
      onClick={() => openImage(i + 1)} // +1 γιατί το lightbox index είναι στο original gallery
      onError={(e) => {
        e.currentTarget.style.display = 'none';
      }}
    />
  ))}
</div>

            </div>
          </div>
        )}
      </section>

      {/* Lightbox full screen */}
      {activeProject && (
        <Lightbox
          open={lightboxOpen}
          close={() => setLightboxOpen(false)}
          index={lightboxIndex}
          slides={activeProject.gallery.map((src) => ({ src }))}
          on={{
            view: ({ index }) => setLightboxIndex(index),
          }}
        />
      )}
    </>
  );
}

export default ProjectsSection;
